import { EnumOption } from "./enum-option"

export const MatterPendingLocation = {
  NationalBenefitsCenter: 0,
  ServiceCenterCalifornia: 1,
  ServiceCenterNebraska: 2,
  ServiceCenterPotomac: 3,
  ServiceCenterTexas: 4,
  ServiceCenterVermont: 5
}

export const MatterPendingLocationList: EnumOption[] = [
    { value: MatterPendingLocation.NationalBenefitsCenter, label: 'National Benefits Center' },
    { value: MatterPendingLocation.ServiceCenterCalifornia, label: 'Service Center - California' },
    { value: MatterPendingLocation.ServiceCenterNebraska, label: 'Service Center - Nebraska' },
    { value: MatterPendingLocation.ServiceCenterPotomac, label: 'Service Center - Potomac' },
    { value: MatterPendingLocation.ServiceCenterTexas, label: 'Service Center - Texas' },
    { value: MatterPendingLocation.ServiceCenterVermont, label: 'Service Center - Vermont' },
]
